module.exports = __webpack_public_path__ + "img/sleeve_cap.1968800c.png";